import PlantCategory from '@/models/PlantCategory';
import PlantCategoriesService from '@/services/PlantCategoriesService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const usePlantCategoriesStore = defineStore('plant_categories', {
  state: () => ({}),

  getters: {
    models: () => useRepo(PlantCategory),
  },

  actions: {
    async searchPlantCategories(projectId: Id, searchData: ApiRequests['api.v1.plant-categories.search'] = {}) {
      const [data, error] = await PlantCategoriesService.search(projectId, searchData);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async createPlantCategory(projectId: Id, request: ApiRequests['api.v1.plant-categories.store']) {
      const [data, error] = await PlantCategoriesService.create(projectId, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async updatePlantCategory(id: Id, request: ApiRequests['api.v1.plant-categories.update']) {
      const [data, error] = await PlantCategoriesService.update(id, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async deletePlantCategory(id: Id) {
      const [data, error] = await PlantCategoriesService.delete(id);

      if(error) {
        throw error;
      }

      this.models.destroy(data.id);

      return data;
    },
  },
});
